<!--
 * @title: 预防性养护
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/24 15:02
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <d2-container>
        <page-body
                :page-size="paging.limit"
                :total="paging.total"
                :current-page="paging.page"

                @size-change="onPagingSizeChange"
                @current-change="onPagingCurrentLimitChange" v-show="!dialogShow">
            <template v-slot:default>
                <page-table
                        :buttons="buttons"
                        :table-column-attributes="pageConfig.tableColumnAttributes"
                        :value="tableData"
                        :toolbar-buttons="toolbarButtons"
                        :loading="loading"
                        @search-click="onSearch"
                        @add-click="onAdd"
                        @look-click="onLook"
                        @update-click="onUpdate"
                        @delete-click="onDelete"
                        :handle-column="true"
                >
                    <template v-slot:advanced-search>
                        <popover-form :form-config="searchConfig" v-model="search" @onSubmit="onSearch"></popover-form>
                    </template>
                </page-table>
            </template>
        </page-body>
        <page-edit-layout v-model="dialogValue" v-show="dialogShow">
            <template v-slot:button>
                <div class="common-flex-center-end">
                    <el-button type="primary" v-if="operationType==2" @click="dataSubmit">保存措施</el-button>
                    <el-button type="primary" v-if="operationType==1" @click="dataGetCS">制定规划措施</el-button>
                    <el-button type="primary" @click="dialogShow = false">返回</el-button>
                </div>
            </template>
            <template v-slot>
                <divider title="基础数据"></divider>
                <dynamic-form ref="dialogValue" :form-config="dialogFormConfig" :disabled="!(operationType==1)" v-model="dialogValue"></dynamic-form>
                <el-dialog :visible.sync="dialogTableVisible" width="80%" custom-class="dialogStyle">
                    <PavementPlanningManagement  class="dialog-top" :tableUse="tableUses"></PavementPlanningManagement>
                </el-dialog>
                <divider title="初选表"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.primaryTableColumnAttributes"
                            :value="pageConfig.primaryTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div>
                <divider title="复选表"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.checkTableColumnAttributes"
                            :value="pageConfig.checkTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div>
                <divider title="终选表"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.finalTableColumnAttributes"
                            :value="pageConfig.finalTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div>
                <divider title="时机表"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.opportunityTableColumnAttributes"
                            :value="pageConfig.opportunityTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div>
                <divider title=""></divider>
            </template>
        </page-edit-layout>
    </d2-container>
</template>

<script>
    import PageBody from "@/components/Pages/PageBody";
    import PageTable from "@/components/Pages/PageTable/index";
    import PageEditLayout from "@/components/Pages/layout/PageEditLayout";
    import PavementPlanningManagement from "@/views/decision/PavementPlanningManagement/index"
    export default {
        name: "index",
        components: {PageEditLayout, PageTable, PageBody,PavementPlanningManagement},
        data() {
            return {
                initializeForm:{},
                dialogTableVisible:false,
                tableUses: {
                    //数据弹框
                    show: true,
                    size: "mini",
                    type: "success",
                    plain: true,
                    round: false,
                    circle: false,
                    loading: false,
                    disabled: false,
                    icon: "",
                    types: 1,
                    title: "使用",
                    name: "使用",
                    click: this.useRoute
                },
                //分页
                paging: {},
                //搜索数据
                search: {routeCode:"",drivingDirection:""},
                //表格数据
                tableData: [],
                //页面配置
                pageConfig: {
                    // 表格列属性
                    tableColumnAttributes: [
                        {label: '规划批次名称', prop: 'partitionName', type: 'String', width: 'auto', children: []},
                        {label: '路线编码', prop: 'routeCode', type: 'String', width: 'auto', children: []},
                        {label: '路线名称', prop: 'routeName', type: 'String', width: 'auto', children: []},
                        {label: '规划类型', prop: 'routeType', type: 'enum1', width: 'auto', children: []},
                        {label: '行车方向', prop: 'drivingDirection', type: 'String', width: 'auto', children: []},
                        {label: '预防性养护路段里程(km)', prop: 'maintainSectionMileage', type: 'Number', width: '260', children: []},
                        {label: '预防养护路段费用(万元)', prop: 'maintainSectionCost', type: 'Number', width: 'auto', children: []},
                        {label: '备注', prop: 'remark', type: 'String', width: 'auto', children: []},
                    ],
                    // 初选表格列属性
                    primaryTableColumnAttributes: [
                        {label: '养护路段编号', prop: 'sectionCode', type: 'String', width: 'auto', children: []},
                        {label: '路线编码', prop: 'routeCode', type: 'String', width: 'auto', children: []},
                        {label: '公路等级', prop: 'highwayCode', type: 'String', width: 'auto', children: []},
                        {label: '分析年度', prop: 'analyzeYear', type: 'String', width: 'auto', children: []},
                        {label: '主要病害1', prop: 'mainDisease1', type: 'String', width: 'auto', children: []},
                        {label: '主要病害2', prop: 'mainDisease2', type: 'String', width: 'auto', children: []},
                        {label: '主要病害3', prop: 'mainDisease3', type: 'String', width: 'auto', children: []},
                        {label: '初选措施', prop: 'primaryMeasure', type: 'String', width: 'auto', children: []},
                        {label: '备注', prop: 'remark', type: 'String', width: 'auto', children: []},
                    ],
                    primaryTableData: [],
                    // 复选表格列属性
                    checkTableColumnAttributes: [
                        {label: '养护路段编号', prop: 'sectionCode', type: 'String', width: 'auto', children: []},
                        {label: '分析年度', prop: 'analyzeYear', type: 'String', width: 'auto', children: []},
                        {label: '初选措施', prop: 'primaryMeasure', type: 'String', width: 'auto', children: []},
                        {label: '使用寿命(年)', prop: 'life', type: 'Number', width: 'auto', children: []},
                        {label: '单元成本(元/㎡)', prop: 'cost', type: 'Number', width: 'auto', children: []},
                        {label: '复选措施', prop: 'checkMeasure', type: 'String', width: 'auto', children: []},
                        {label: '备注', prop: 'remark', type: 'String', width: 'auto', children: []},
                    ],
                    checkTableData: [],
                    // 终选表格列属性
                    finalTableColumnAttributes: [
                        {label: '养护路段编号', prop: 'sectionCode', type: 'String', width: 'auto', children: []},
                        {label: '分析年度', prop: 'analyzeYear', type: 'String', width: 'auto', children: []},
                        {label: '复选措施', prop: 'checkMeasure', type: 'String', width: 'auto', children: []},
                        {label: '综合评判系数', prop: 'k', type: 'Number', width: 'auto', children: []},
                        {label: '终选措施', prop: 'finalMeasure', type: 'String', width: 'auto', children: []},
                        {label: '备注', prop: 'remark', type: 'String', width: 'auto', children: []},
                    ],
                    finalTableData: [],
                    // 时机表格列属性
                    opportunityTableColumnAttributes: [
                        {label: '养护路段编号', prop: 'sectionCode', type: 'String', width: 'auto', children: []},
                        {label: '分析年度', prop: 'analyzeYear', type: 'String', width: 'auto', children: []},
                        {label: '路线编码', prop: 'routeCode', type: 'String', width: 'auto', children: []},
                        {label: '行车方向', prop: 'drivingDirection', type: 'String', width: 'auto', children: []},
                        {label: '车道位置', prop: 'lane', type: 'String', width: 'auto', children: []},
                        {label: '面层类型', prop: 'surfaceType', type: 'String', width: 'auto', children: []},
                        {label: '起点桩号', prop: 'startStake', type: 'Stake', width: 'auto', children: []},
                        {label: '止点桩号', prop: 'endStake', type: 'Stake', width: 'auto', children: []},
                        {label: '终选措施', prop: 'finalMeasure', type: 'String', width: 'auto', children: []},
                        {label: '预防性养护效益指数PBI', prop: 'pbi', type: 'Number', width: 'auto', children: []},
                        // {label: '费用总现值PW', prop: 'pw', type: 'Number', width: 'auto', children: []},
                        // {label: '当量平均年度费用EUAC', prop: 'euac', type: 'Number', width: 'auto', children: []},
                        {label: '效益费用比BCR', prop: 'bcr', type: 'Number', width: 'auto', children: []},
                        {label: '养护年份', prop: 'maintainYear', type: 'Number', width: 'auto', children: []},
                        {label: '预防性养护路段费用(万元)', prop: 'maintainSectionCost', type: 'Number', width: 'auto', children: []},
                    ],
                    opportunityTableData: []
                },
                // 工具栏按钮
                toolbarButtons: this.ButtonEnums.BarButton.addButton,
                // 表格加载
                loading: false,
                // 查看模式
                lookModel: false,
                //操作类型
                operationType: 1,
                // 弹出层数据
                dialogValue: {
                    rowCode :0,/// 主键id  int
                    partitionId :0,/// 规划id  int
                    partitionName :'',/// 规划名称（路线名称+规划年度+路面养护规划）
                    routeId :0,/// 路线id
                    routeCode :'',/// 路线编码
                    routeName :'',/// 路线名称
                    routeType :'',/// 路线类型：1-路线(项目级)；2-路网(网级)；
                    drivingDirection :'',/// 行车方向
                    maintainSectionMileage :0,/// 预防性养护路段里程(km)int
                    maintainSectionCost :0,/// 预防性养护路段费用(万元)int
                    remark :'',/// 备注
                    status :'',/// 状态
                    createUser :'',
                    createUserName :'',
                    createTime :'',
                    updateUser :'',
                    updateUserName :'',
                    updateTime :'',
                    isDelete :'',
                    deleteUser :'',
                    deleteUserName :'',
                    deleteTime :'',
                    r1 :'',
                    r2 :'',
                    r3 :'',
                    r4 :'',
                    r5 :'',
                    fSublist :[],//List初选表
                    sSublist :[],//List复选表
                    tSublist :[],//List终选表
                    oSublist :[],//List时机表
                },
                dialogValueKid:{
                    F:{//初选表
                        rowCode :0,/// 主键id  int
                        pCode :0,/// 主表id  int
                        routeSectionId :'',/// 养护路段id
                        sectionCode :'',/// 养护路段编号
                        analyzeYear :0,/// 分析年度    int
                        routeId :'',/// 路线id
                        routeCode :'',/// 路线编码
                        routeName :'',/// 路线名称
                        routeType :'',/// 路线类型：1-路线；2-路网；
                        highwayCode :'',/// 公路等级
                        mainDisease1 :'',/// 主要病害1
                        mainDisease2 :'',/// 主要病害2
                        mainDisease3 :'',/// 主要病害3
                        primaryMeasure :'',/// 初选措施
                        remark :'',/// 备注
                        status :'',/// 状态
                        createUser :'',
                        createUserName :'',
                        createTime :'',
                        updateUser :'',
                        updateUserName :'',
                        updateTime :'',
                        isDelete :'',
                        deleteUser :'',
                        deleteUserName :'',
                        deleteTime :'',
                        r1 :'',
                        r2 :'',
                        r3 :'',
                        r4 :'',
                        r5 :'',
                    },
                    S:{//复选表
                        rowCode :0,
                        pCode :0,
                        analyzeYear :0,/// 分析年度    int
                        routeId :'',
                        routeCode :'',
                        routeName :'',
                        routeSectionId :0,/// 养护路段id
                        sectionCode :'',/// 养护路段编号
                        primaryMeasure :'',/// 初选措施
                        life :0,/// 使用寿命    int
                        cost :0,/// 单价成本    decimal
                        checkMeasure :'',/// 复选措施
                        remark :'',
                        status :'',
                        createUser :'',
                        createUserName :'',
                        createTime :'',
                        updateUser :'',
                        updateUserName :'',
                        updateTime :'',
                        isDelete :'',
                        deleteUser :'',
                        deleteUserName :'',
                        deleteTime :'',
                        r1 :'',
                        r2 :'',
                        r3 :'',
                        r4 :'',
                        r5 :'',
                    },
                    T:{//终选表
                        rowCode :0,
                        pCode :0,
                        analyzeYear :0,/// 分析年度    int
                        routeId :0,
                        routeCode :'',
                        routeName :'',
                        routeSectionId :0,/// 养护路段id
                        sectionCode :'',/// 养护路段编号
                        checkMeasure :'',/// 复选措施
                        factor :'',/// 影响因素
                        k:"",//综合评判系数
                        weight :0,/// 权重系数    decimal
                        score :0,/// 分值    decimal
                        finalMeasure :'',/// 终选措施
                        remark :'',
                        status :'',
                        createUser :'',
                        createUserName :'',
                        createTime :'',
                        updateUser :'',
                        updateUserName :'',
                        updateTime :'',
                        isDelete :'',
                        deleteUser :'',
                        deleteUserName :'',
                        deleteTime :'',
                        r1 :'',
                        r2 :'',
                        r3 :'',
                        r4 :'',
                        r5 :'',
                    },
                    O:{//时机表
                        rowCode :0,/// 主键id  int
                        pCode :0,/// 主表id  int
                        routeSectionId :0,/// 养护路段id
                        sectionCode :'',/// 养护路段编号
                        drivingDirection :'',/// 行车方向
                        lane :'',/// 车道位置
                        surfaceType :'',/// 面层类型
                        startStake :0,/// 起点桩号    decimal
                        endStake :0,/// 止点桩号    decimal
                        routeId :'',/// 路线id
                        routeCode :'',/// 路线编码
                        routeName :'',/// 路线名称
                        analyzeYear :0,/// 分析年度    int
                        finalMeasure :'',/// 终选措施
                        pbi :0,/// 预防性养护效益指数PBI   decimal
                        pw :0,/// 费用总现值PW    decimal
                        euac :0,/// 当量平均年度费用EUAC    decimal
                        bcr :0,/// 效益费用比BCR   decimal
                        maintainYear :0,/// 养护年份    int
                        maintainSectionCost :0,/// 预防性养护路段费用(万元)    decimal
                        remark :'',/// 备注
                        status :'',/// 状态
                        createUser :'',
                        createUserName :'',
                        createTime :'',
                        updateUser :'',
                        updateUserName :'',
                        updateTime :'',
                        isDelete :'',
                        deleteUser :'',
                        deleteUserName :'',
                        deleteTime :'',
                        r1 :'',
                        r2 :'',
                        r3 :'',
                        r4 :'',
                        r5 :'',
                    }
                },
                //搜索框配置
                searchConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": false,
                            "remoteFunc": "func_1590737829000_62492"
                        },
                        "name": "路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "路线编码格式不正确"}]
                    },
                    {
                      "type": "select",
                      "icon": "icon-select",
                      "options": {
                        "defaultValue": "",
                        "multiple": false,
                        "disabled": false,
                        "clearable": false,
                        "placeholder": "请选择",
                        "required": false,
                        "showLabel": false,
                        "width": "250px",
                        "options": [
                          {
                            "value": "Option 1"
                          }
                        ],
                        "remote": true,
                        "remoteType": "func",
                        "remoteOption": "option_1584863720132",
                        "filterable": false,
                        "remoteOptions": [],
                        "props": {
                          "value": "name",
                          "label": "name"
                        },
                        "remoteFunc": this.getDiction,
                        "customClass": "",
                        "labelWidth": 100,
                        "isLabelWidth": false,
                        "hidden": false,
                        "dataBind": true
                      },
                      "name": "行车方向",
                      "key": "1584863720132",
                      "model": "drivingDirection",
                      "rules": [
                      ]
                    },], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small"}
                },
                // 弹出层表单配置
                dialogFormConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": true,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请选择批次名称",
                            "disabled": false,
                            "remoteFunc": "func_1590656787000_34771",
                            onFocus: this.routeFileForm
                        },
                        "name": "规划批次名称",
                        "key": "partitionName",
                        "model": "partitionName",
                        "rules": [{"type": "string", "message": "规划批次名称格式不正确"}, {
                            "required": true,
                            "message": "规划批次名称必须填写"
                        }]
                    }, {
                        "type": "select",
                        "icon": "icon-select",
                        "options": {
                            "defaultValue": "",
                            "multiple": false,
                            "disabled": true,
                            "clearable": false,
                            "placeholder": "系统自动生成",
                            "required": false,
                            "requiredMessage": "",
                            "showLabel": false,
                            "width": "",
                            "options": [
                                {
                                    "label":"项目级",
                                    "value": "1"
                                },
                                {
                                    "label":"路网级",
                                    "value": "2"
                                }
                            ],
                            "remote": false,
                            "remoteType": "option",
                            "remoteOption": "option_1593590909123",
                            "filterable": false,
                            "remoteOptions": [],
                            "props": {
                                "value": "value",
                                "label": "label"
                            },
                            "remoteFunc": "func_1593590909123",
                            "customClass": "",
                            "labelWidth": 100,
                            "isLabelWidth": false,
                            "hidden": false,
                            "dataBind": true
                        },
                        "name": "规划类型",
                        "key": "1593590909123",
                        "model": "routeType",
                        "rules": [

                        ]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1590656787000_34771"
                        },
                        "name": "路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "路线编码格式不正确"}, {
                            "required": false,
                            "message": "路线编码必须填写"
                        }]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "系统自动生成",
                            "disabled": true,
                            "remoteFunc": "func_1590656787000_34771"
                        },
                        "name": "行车方向",
                        "key": "drivingDirection",
                        "model": "drivingDirection",
                        "rules": [{"type": "string", "message": "行车方向格式不正确"}, {"required": false, "message": "行车方向必须填写"}]
                    }, {
                        "type": "number",
                        "icon": "icon-number",
                        "options": {
                          "width": "",
                          "required": false,
                          "defaultValue": 0,
                          "min": 0,
                          "max": 99999999999,
                          "step": 0.001,
                          "precision": 0,
                          "disabled": true,
                          "controlsPosition": "",
                          "customClass": "",
                          "labelWidth": 100,
                          "isLabelWidth": false,
                          "hidden": false,
                          "dataBind": true,
                        },
                        "name": "预防性养护路段里程(km)",
                        "key": "maintainSectionMileage",
                        "model": "maintainSectionMileage",
                        "rules": []
                    }, {
                        "type": "number",
                        "icon": "icon-number",
                        "options": {
                          "width": "",
                          "required": false,
                          "defaultValue": 0,
                          "min": 0,
                          "max": 99999999999,
                          "step": 0.0001,
                          "precision": 0,
                          "disabled": true,
                          "controlsPosition": "",
                          "customClass": "",
                          "labelWidth": 100,
                          "isLabelWidth": false,
                          "hidden": false,
                          "dataBind": true,
                        },
                        "name": "预防性养护路段费用(万元)",
                        "key": "maintainSectionCost",
                        "model": "maintainSectionCost",
                        "rules": []
                    }, {
                        "type": "textarea",
                        "icon": "icon-diy-com-textarea",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "disabled": false,
                            "pattern": "",
                            "placeholder": "请输入备注",
                            "remoteFunc": "func_1590658066000_17985"
                        },
                        "name": "备注",
                        "key": "remark",
                        "model": "remark",
                        "rules": []
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small"}
                },
                // 弹出层控制属性
                dialogShow: false
            }
        },
        methods: {
            getDiction(target, targets) {
              let name = target.form.name;
              this.$http.post(this.$url.getDict, {
                  search: name
                }).then(res => {
                  let { data } = res;
                  target.setList(data);
                });
            },
            //分页大小变更事件
            onPagingSizeChange(size) {
                this.paging.setSize(size)
                this.refreshData(this.paging, this.search)
            },
            // 分页当前页变动事件
            onPagingCurrentLimitChange(current) {
                this.paging.setIndex(current)
                this.refreshData(this.paging, this.search)
            },
            // 搜索事件
            onSearch() {
                this.refreshData(this.paging, this.search);
            },
            // 新增
            onAdd() {
                this.dialogShow = true;
                this.operationType = 1;
                this.dialogValue = this.$formSetForm(this.initializeForm , this.initializeForm);
                this.pageConfig.primaryTableData=[];
                this.pageConfig.checkTableData=[];
                this.pageConfig.finalTableData=[];
                this.pageConfig.opportunityTableData=[];
            },
            // 查看
            onLook(row) {
                this.$http.post(this.$url.routeDecision.getpmdperventivemaintain,{rowCode:row.rowCode}).then(res=>{
                    this.operationType = 3;
                    this.dialogShow = true;
                    this.dialogValue=res.data;
                    if(res.data.fSublist){
                        this.pageConfig.primaryTableData=res.data.fSublist;
                    }else{
                        this.pageConfig.primaryTableData=[];
                    }
                    if(res.data.sSublist){
                        this.pageConfig.checkTableData=res.data.sSublist;
                    }else{
                        this.pageConfig.checkTableData=[];
                    }
                    if(res.data.tSublist){
                        this.pageConfig.finalTableData=res.data.tSublist;
                    }else{
                        this.pageConfig.finalTableData=[];
                    }
                    if(res.data.oSublist){
                        this.pageConfig.opportunityTableData=res.data.oSublist;
                    }else{
                        this.pageConfig.opportunityTableData=[];
                    }
                })
            },
            // 修改
            onUpdate() {

            },
            // 删除
            onDelete() {

            },
            initial() {
                this.refreshData(this.paging)
            },
            // 刷新数据
            refreshData(paging, search, callback) {
                const searchData = this.Tools.get().ObjectTools.merge(paging, search),
                    url = this.$url.routeDecision.getperventivemaintains
                // 由于web storm模板影响 请自行配置以下代码
                this.loading = true
                this.$http.post(url, searchData).then(res=>{
                    this.tableData=res.data;
                    this.paging.total = res.pageCount;
                    this.loading = false
                }).catch(error=>{
                    this.loading = false
                })
            },
            //规划管理使用
            routeFileForm() {
                this.dialogTableVisible = true;
            },
            useRoute(row, index) {
                this.dialogTableVisible = false
                this.dialogValue.partitionId = row.rowCode
                this.dialogValue.partitionName = row.planName
                this.dialogValue.routeId = row.routeId
                this.dialogValue.routeCode = row.routeCode
                this.dialogValue.routeName = row.routeName
                this.dialogValue.routeType = row.planType
            },
            dataGetCS(){
                this.$refs.dialogValue.submit().then(res => {
                    var forms = this.$formSetForm(this.dialogValue, this.dialogValue);
                    this.$http
                        .postHandle("规划", this.$url.routeDecision.operationperventivemaintain, {
                          perventiveMaintain: forms,
                        })
                        .then(res => {
                            this.dialogValue=res.data;
                            if(res.data.fSublist){
                                this.pageConfig.primaryTableData=res.data.fSublist;
                            }else{
                                this.pageConfig.primaryTableData=[];
                            }
                            if(res.data.sSublist){
                                this.pageConfig.checkTableData=res.data.sSublist;
                            }else{
                                this.pageConfig.checkTableData=[];
                            }
                            if(res.data.tSublist){
                                this.pageConfig.finalTableData=res.data.tSublist;
                            }else{
                                this.pageConfig.finalTableData=[];
                            }
                            if(res.data.oSublist){
                                this.pageConfig.opportunityTableData=res.data.oSublist;
                            }else{
                                this.pageConfig.opportunityTableData=[];
                            }
                            // this.dialogShow = false
                            this.operationType = 2;
                            this.refreshData(this.paging, this.search);
                        })
                        .catch(error => {
                          console.log(error);
                        });
                });
            },
            dataSubmit(){
                this.$refs.dialogValue.submit().then(res => {
                    var forms = this.$formSetForm(this.dialogValue, this.dialogValue);
                    this.$http
                        .postHandle("保存", this.$url.routeDecision.saveperventivemaintain, {
                          perventiveMaintain: forms,
                        })
                        .then(res => {
                            this.dialogShow = false
                            this.refreshData(this.paging, this.search);
                        })
                        .catch(error => {
                          console.log(error);
                        });
                });
            },
        },
        computed: {
            // 表格按钮
            buttons() {
                return this.ButtonEnums.TableButtons.descriptionButton
            }
        },
        mounted() {
            this.paging = this.Paging.default()
            this.initializeForm = this.$formSetForm(this.dialogValue , this.dialogValue)
            this.initial()
        }
    }
</script>

<style scoped lang="scss">

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenance/index.vue"
}
</vue-filename-injector>
